module.exports = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTggMTgiPgogIDxwYXRoIGNsYXNzPSJxbC1maWxsIiBkPSJNIDEyLjkgMiBMIDExLjMgMy42IEwgMTQuOCA3IEwgMTYuMyA1LjUgTCAxMi45IDIgWiBNIDkuMyA1LjUgTCAyIDEyLjIgTCAyIDE1LjUgTCA1LjcgMTUuNSBMIDEzIDguOSBMIDkuMyA1LjUgWiI+PC9wYXRoPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./node_modules/quill-resize-module/src/assets/pencil.svg
// module id = XNbD
// module chunks = 4